import { Show } from "solid-js";
import { EmptyState } from "./primitives";

export function Group(props: {
  title: string;
  empty: boolean;
  children: import("solid-js").JSX.Element;
}) {
  return (
    <section class="tov-group">
      <h2 class="tov-group-title">{props.title}</h2>
      <Show
        when={!props.empty}
        fallback={<EmptyState label={props.title.toLowerCase()} />}
      >
        {props.children}
      </Show>
    </section>
  );
}
